import { Helmet } from "react-helmet";
import LayoutProps from "../services/models/layoutProps.model";

function SignUpPageLayout({ pageTitle, children }: LayoutProps): JSX.Element {
  return (
    <div className="grid grid-cols-[0.5fr,4fr] md:grid-cols-twoEqualColumnLayout h-[100vh] overflow-hidden">
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>
      <div className="signUpGradient"/>
      <main>{children}</main>
    </div>
  );
}

export default SignUpPageLayout;
